import React from 'react';
import {useSelector} from 'react-redux';

import appConfig from '../../config/appConfig';
import SignedImage from '../../containers/System/SignedImage';
import reconnectDeviceGuidePopupService from '../../services/reconnectGuideService';
import {makeSelectIotDeviceMergedWithConsumerProduct} from '../../state/selectors/consumer';
import DevicePrimaryColorContainer from '../Device/DevicePrimaryColorContainer';
import GuideVideo from '../Video/GuideVideo/GuideVideo';

const ReconnectGuideVideo = ({className, videoClassName}) => {
    const {device} = useSelector(makeSelectIotDeviceMergedWithConsumerProduct());
    const {type} = device || {};
    const {mediaData, defaultImage} = reconnectDeviceGuidePopupService.getImageData(type);
    const guideDataList = reconnectDeviceGuidePopupService.getReconnectListData(type);
    const {reconnectData} = guideDataList || {};
    const {video, videoStartTime, videoStopTime, thumbnail} = reconnectData;
    const isRestrictedMarket = appConfig.getIsRestrictedMarket();
    const isVideoContainer = !!video;
    const Container = isVideoContainer ? DevicePrimaryColorContainer : 'div';

    return (
        <Container className={className}>
            {isVideoContainer ? (
                <GuideVideo
                    content={[{videoStartTime, videoStopTime}]}
                    src={video}
                    thumbnailSrc={thumbnail}
                    containerClassName={videoClassName}
                    className='absolute left-1/2 top-1/2 z-10 -translate-x-1/2 -translate-y-1/2'
                    controlsClassName='m-0 right-4 left-[unset] z-20 rtl:left-4 rtl:right-[unset]'
                />
            ) : (
                <SignedImage
                    imgClassName='w-full'
                    defaultImage={isRestrictedMarket ? undefined : defaultImage}
                    isThumbnailAvailable
                    mediaData={mediaData}
                    signIfNull
                />
            )}
        </Container>
    );
};

export default ReconnectGuideVideo;
